import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleEllipsis,
  faCircleXmark
} from '@fortawesome/pro-regular-svg-icons';
import { Badge } from '@morressier/alembic';
import { exportConfigItem } from '@publishing-engine/domain/models';
import { testExportConnections } from 'src/api/queries';
import { FieldErrors } from 'react-hook-form';
import { IExportFormValues } from '@publishing-engine/domain/models/vendor-exports';

export const renderBadge = (status: string) => {
  switch (status) {
    case 'complete':
      return (
        <Badge variant="success">
          <FontAwesomeIcon icon={faCircleCheck}></FontAwesomeIcon>
          {' Success'}
        </Badge>
      );
    case 'failed':
      return (
        <Badge variant="caution">
          <FontAwesomeIcon icon={faCircleXmark}></FontAwesomeIcon>
          {' Failed'}
        </Badge>
      );
    default:
      return (
        <Badge variant="attention">
          <FontAwesomeIcon icon={faCircleEllipsis}></FontAwesomeIcon>
          {' In Progress'}
        </Badge>
      );
  }
};

export const STATUS_FILTER_MAP: Record<
  'success' | 'failed' | 'inProgress',
  string
> = {
  success: 'complete',
  failed: 'failed',
  inProgress: 'initialized'
};

export const getTodayFullDayRange = (): [string, string] => {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');

  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )}`;

  return [today, today];
};

export const testConnections = async (values: exportConfigItem, toast: any) => {
  const serverInfo = values.serverInfo;
  try {
    const response = await testExportConnections(
      values.exportConfigType,
      JSON.stringify(serverInfo)
    );
    toast({
      variant: response.success ? 'success' : 'error',
      title: response.success ? 'Connection successful' : 'Connection failed',
      description: response.success
        ? 'Server details verified'
        : 'Please check your server details'
    });

    return response.success;
  } catch {
    toast({
      variant: 'error',
      title: 'Connection failed',
      description: 'Please verify server details before retrying.'
    });

    return false;
  }
};

export const getServiceAccountError = (
  serviceAccountFileName: string | null,
  errors: FieldErrors<IExportFormValues>
) => {
  if (!serviceAccountFileName) {
    return 'Please upload a service account JSON file';
  }

  if (
    errors.serverInfo?.private_key ||
    errors.serverInfo?.client_email ||
    errors.serverInfo?.project_id
  ) {
    return 'Invalid service account file. Required fields are missing.';
  }

  return null;
};
